import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "developerHome" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", null, "Dev / Users", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Redirecting to login... ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$store.state.Auth.user.developer == true)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_2,
          _createElementVNode("h4", null, "Welcome back, " + _toDisplayString(_ctx.$store.state.Auth.user.name), 1)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_3
        ], 64))
  ]))
}